import { render, staticRenderFns } from "./LogoSetting.vue?vue&type=template&id=1aeefa1c&"
import script from "./LogoSetting.vue?vue&type=script&lang=js&"
export * from "./LogoSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports